export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-14 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Georgia, serif' }}>
            Get In Touch
          </h2>
          <p className="text-lg text-gray-600 max-w-xl mx-auto">
            Have questions or ready to start your recovery journey? Reach out — we&apos;d love to hear from you.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          <div className="bg-white rounded-2xl p-8 text-center border border-gray-100">
            <div className="w-14 h-14 rounded-full bg-teal-700 flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-2xl text-white"></i>
            </div>
            <h4 className="font-semibold text-gray-900 mb-2">Phone</h4>
            <a href="tel:0731425833" className="block text-gray-600 hover:text-teal-700 transition-colors cursor-pointer text-sm">07 3142 5833</a>
            <a href="tel:0485683288" className="block text-gray-600 hover:text-teal-700 transition-colors cursor-pointer text-sm mt-1">0485 683 288</a>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center border border-gray-100">
            <div className="w-14 h-14 rounded-full bg-teal-700 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-2xl text-white"></i>
            </div>
            <h4 className="font-semibold text-gray-900 mb-2">Email</h4>
            <a href="mailto:jagroop@auraalignphysio.com" className="block text-gray-600 hover:text-teal-700 transition-colors cursor-pointer text-sm break-all">
              jagroop@auraalignphysio.com
            </a>
            <p className="text-gray-400 text-xs mt-1">Jagroop Kaur</p>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center border border-gray-100">
            <div className="w-14 h-14 rounded-full bg-teal-700 flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-line text-2xl text-white"></i>
            </div>
            <h4 className="font-semibold text-gray-900 mb-2">Address</h4>
            <p className="text-gray-600 text-sm leading-relaxed">
              Shop 1A/9 Elizabeth Ave<br />
              Clontarf QLD 4019<br />
              Australia
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 text-center border border-gray-100">
            <div className="w-14 h-14 rounded-full bg-teal-700 flex items-center justify-center mx-auto mb-4">
              <i className="ri-instagram-line text-2xl text-white"></i>
            </div>
            <h4 className="font-semibold text-gray-900 mb-2">Instagram</h4>
            <a
              href="https://www.instagram.com/auraalign_physio"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-gray-600 hover:text-teal-700 transition-colors cursor-pointer text-sm"
            >
              @auraalign_physio
            </a>
            <p className="text-gray-400 text-xs mt-1">Follow us</p>
          </div>
        </div>

        <div className="rounded-3xl overflow-hidden border border-gray-100 relative" style={{ height: '420px' }}>
          <iframe
            src="https://maps.google.com/maps?q=Shop+1A+9+Elizabeth+Ave+Clontarf+QLD+4019+Australia&t=&z=16&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Aura Align Physio Location"
          ></iframe>
          <div className="absolute bottom-6 left-6 bg-white rounded-2xl p-6 border-l-4 border-teal-700">
            <h4 className="font-bold text-gray-900 mb-3">Clinic Hours</h4>
            <div className="space-y-1 text-sm text-gray-600">
              <div className="flex justify-between space-x-8"><span className="font-medium">Monday - Friday:</span><span>8:00 AM - 6:00 PM</span></div>
              <div className="flex justify-between space-x-8"><span className="font-medium">Saturday:</span><span>9:00 AM - 2:00 PM</span></div>
              <div className="flex justify-between space-x-8"><span className="font-medium">Sunday:</span><span>Closed</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
